import { createI18n, I18n } from "vue-i18n";
import { setLanguage } from "@/utils/storage";
import userService from "@/api/services/userService";
import { useUserStore } from "@/store/user";
import { getTld } from "@/utils/urlHelper.ts";

async function loadLocaleMessages(lang: string): Promise<Record<string, unknown>> {
  if (lang === "en") {
    return {};
  }

  if (getTld() === "net") {
    return {};
  }

  if (lang === "de") {
    const m = await import("./locales/de.json");
    return (m.default || m) as Record<string, unknown>;
  }

  if (lang === "fr") {
    const m = await import("./locales/fr.json");
    return (m.default || m) as Record<string, unknown>;
  }

  return {};
}

const i18n: I18n = createI18n({
  silentTranslationWarn: true,
  silentFallbackWarn: true,
  warnHtmlInMessage: "off",
  locale: "en",
  messages: {},
});

export default i18n;

export const changeLanguage = async (neededLang?: "en" | "de" | "fr") => {
  const lang = neededLang ? neededLang : i18n.global.locale === "de" ? "en" : "de";

  if (!(i18n.global.messages as Record<string, string>)[lang]) {
    const messageData = await loadLocaleMessages(lang);
    i18n.global.setLocaleMessage(lang, messageData);
  }

  document.body.classList.remove("lang_en", "lang_de");
  document.body.classList.add(`lang_${lang}`);

  if (i18n.global.locale === lang) {
    return;
  }

  const userStore = useUserStore();

  if (userStore.getProfile) {
    userService.switchLang(lang);
  }

  i18n.global.locale = lang;
  setLanguage(lang);
};
